"use strict";

export const initCookiesBox = async function(cookiesWrapperSelector, changeCookiesSelector, forceOpen = false) {
    const cookiesWrapper = document.querySelector(cookiesWrapperSelector)
    if (!cookiesWrapper) {
        console.log('Cookies Box is missing!')
        return;
    }
    try {
        const module = await import('../cookies/cookie-box');
        module.initCookiesBox(cookiesWrapperSelector, changeCookiesSelector, forceOpen);
    } catch (error) {
        console.error("Failed to initialize Cookies Box:", error);
    }
}